import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  API_LOADING_ERROR,
  API_NOT_FOUND_ERROR,
  ERROR_STATUS_CODES,
  API_NO_DATA_FOUND_ERROR,
} from "@/lib/errors/error-constants";

/**
 * @typedef GetTotalStatistics
 * @property {string} Resource_Type
 * @property {number} saving
 * @property {number} vm
 * @property {number} ip
 * @property {number} disk
 * @property {number} lb
 */

/**
 * @typedef GetStatisticsReq
 * @property {'aws' | 'gcp' | 'azure'  } service
 * @property {'ip' | 'disk' | 'vm' | 'lb' | 'all'} resourceType
 * @property {number} page
 * @property {number} recordsPerPage
 * @property {number} idleDays
 */

export const getIndividualBarGraph = (token) => {
  /**
   * @param {GetStatisticsReq} req
   * @returns {Promise<GetTotalStatistics>}
   */
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/recommendations/statistics`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (data?.stats?.total === 0) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return data;
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const useIndividualBarGraph = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getIndividualBarGraph", req, ...deps],
    queryFn: () => getIndividualBarGraph(appContext.idToken)(req),
  });
  return query;
};
